import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

import CartItem from "../components/CartItem";
import OrderProduct from "./OrderProduct";

const cartText = {
  title: "Кошничка",
  intro:
    "Прегледајте ги избраните производи, прилагодете количина и завршете ја нарачката брзо и едноставно.",
  itemsInCart: "производи во кошничка",
  deliveryTime: "2-3 дена",
  expectedDelivery: "очекувана достава",
  orderValue: "вкупна вредност на нарачката",
  readyForOrder: "Подготвено за нарачка",
  itemsLabel: "ставки",
  orderOverview: "Преглед на нарачка",
  products: "Производи",
  shipping: "Испорака",
  shippingValue: "По договор",
  total: "Вкупно",
  summaryNote:
    "Потврдата и деталите за достава ќе ги добиете по телефон по испратената нарачка.",
  continueShopping: "Продолжи со купување",
  emptyTitle: "Вашата кошничка е празна",
  emptyText:
    "Изберете телефон, часовник или галантерија и вратете се овде кога ќе бидете подготвени.",
  removed: "Продуктот е избришан од вашата кошничка",
};

function Cart() {
  const [products, setProducts] = useState(
    JSON.parse(sessionStorage.getItem("cart")) || []
  );
  const [totalProductp, setTotalproductp] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    document.title = "Cart | Buzz Mobile";

    const current = sessionStorage.getItem("cart");
    if (current) {
      calculateTotalPrice(JSON.parse(current));
    }
  }, []);

  const deleteCartProduct = (id) => {
    let current = sessionStorage.getItem("cart");

    if (!current) {
      current = [];
    } else {
      current = JSON.parse(current);
    }

    current.splice(
      current.findIndex((item) => item.id === id),
      1
    );

    sessionStorage.setItem("cart", JSON.stringify(current));

    setProducts(products.filter((item) => item.id !== id));
    calculateTotalPrice(current);
    setShow(true);
    setTimeout(() => {
      setShow(false);
    }, 2000);
  };

  const calculateTotalPrice = (cartProducts) => {
    setTotalproductp(
      cartProducts.reduce(
        (accumulator, current) =>
          accumulator + current.price * current.quantity,
        0
      )
    );
  };

  const totalItems = products.reduce(
    (accumulator, current) => accumulator + current.quantity,
    0
  );

  return (
    <div className="cart-page container">
      

      {products.length > 0 ? (
        <div className="cart-page__content">
          <section className="cart-page__main">
            <div className="cart-page__section-heading">
              <div>
                <span className="cart-page__section-label">Избрани продукти</span>
                <h2>{cartText.readyForOrder}</h2>
              </div>
           
            </div>

            <div className="cart-page__items">
              {products.map((product, index) => (
                <CartItem
                  key={index}
                  product={product}
                  deleteCartProduct={deleteCartProduct}
                  calculateTotalPrice={calculateTotalPrice}
                />
              ))}
            </div>
          </section>

          <aside className="cart-page__summary">
            <div className="cart-page__summary-card">
              <h2>{cartText.orderOverview}</h2>

              <div className="cart-page__summary-row">
                <span>{cartText.products}</span>
                <strong>{totalItems}</strong>
              </div>
              <div className="cart-page__summary-row">
                <span>{cartText.shipping}</span>
                <strong>{cartText.shippingValue}</strong>
              </div>
              <div className="cart-page__summary-row cart-page__summary-row--total">
                <span>{cartText.total}</span>
                <strong>{parseFloat(totalProductp || 0).toLocaleString("en")} ден.</strong>
              </div>

              <p className="cart-page__summary-note">{cartText.summaryNote}</p>

              <div className="cart-page__actions">
                <div className="continue__shopping continue">
                  <Link to="/">{cartText.continueShopping}</Link>
                </div>
                <div className="cart-page__order">
                  <OrderProduct
                    products={sessionStorage.getItem("cart")}
                    cartOrder={true}
                  />
                </div>
              </div>
            </div>
          </aside>
        </div>
      ) : (
        <div className="cart-page__empty">
          <Alert severity="error">{cartText.emptyTitle}</Alert>
          <p>{cartText.emptyText}</p>
          <div className="continue__shopping">
            <Link to="/">{cartText.continueShopping}</Link>
          </div>
        </div>
      )}

      {show ? (
        <div className="addtocart__popup cart">
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert severity="warning">
              <p>{cartText.removed}</p>
            </Alert>
          </Stack>
        </div>
      ) : null}
    </div>
  );
}

export default Cart;
